import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import { Image, div, Row, Col } from 'react-bootstrap';
import KlentyLogo from 'src/legacy/images/klenty_logo.png';
import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import BackButton from 'src/legacy/components/BackButton';
import KlentyAuthenticationPage from './KlentyAuthenticationPage.jsx';
import { localizedStrings } from 'src/localization/index.jsx';
import { shouldFetchIntegrations } from 'src/legacy/redux/actions/integrations';

class klentyView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.state={
      deleteConfirmation: false
    }

    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedKlenty = localizedStrings.components.integrations.klenty;
  }

  componentDidMount() {
    
    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
  }

  _handleDeactivateClicked() {
    this.setState({
      deleteConfirmation: true
    })
  }

  render() {

    var isAuthenticated = false;

    if (this.props.integration && this.props.integration.state.code === "ok" && !this.props.error) {
      isAuthenticated = true;
    }
    return (
      <div className={styles.content} fluid>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>

            <BackButton className={styles.back} title={this.localizedCommons.actions.back} onClick={() => {
              this.props.navigate('/settings/integrations');
            }} />

            <div className={styles.heading}>
              <Image src={KlentyLogo} />
              <h2 className={styles.name}>{ this.localizedKlenty.title }</h2>
              <p className={styles.description}>{ this.localizedKlenty.sub_text }</p>

              {this.props.integration &&
                <button className={styles.button} disabled={this.props.deactivating} onClick={this._handleDeactivateClicked}>
                  {this.props.deactivating && `${this.localizedIntegrations.actions.deactivating}...`}
                  {!this.props.deactivating && this.localizedIntegrations.actions.deactivate }
                </button>
              }
            </div>
          </Col>
          <Col md={9} className={styles.right}>
            {this.props.integration && this.props.integration.state.code === "auth_error" &&
              <span className={styles.authMessage}>{`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}</span>}
              
            <KlentyAuthenticationPage store={this.context.store}/>
          </Col>
        </Row>
        <DeactivateIntegrationContainer 
          name = {this.localizedKlenty.title}
          type="klenty"
          message={this.localizedKlenty.deactive_slider.sub_text}
          show={this.state.deleteConfirmation}
          onCancel={()=> {
          this.setState({
             deleteConfirmation: false
          })
        }}
       />
      </div>
    );
  }
}

export default klentyView;